/**
 * User: Keith
 * Author: Faris
 * Date: 6/29/2015
 * Time: 11:14 PM
 */

define('app/models/page',[],function () {

  return Backbone.Model.extend({

    idAttribute:'ID',

    initialize: function(attributes, options){
      Backbone.Model.prototype.initialize.call(this, attributes, options);
    },

    url: function(){
      return '/library/ajax/get_page_content.cfm'
    },

    sync: function(method, model, options){
      options.processData = true;

      if(!options.data) {
        var path = this.get('PATH').replace(/\/$/, "");
        options.data = { PATH: path == '' ? '/' : path };
      }

      return Backbone.sync(method, model, options);
    },

    parse: function(response){
      response = flattenQuery(response);

      if(response.results){
        return response.results;
      }

      return response;
    }
  });

});
